import type { MenuItem } from "../types";

export const compactMenuItems = (
  items: Array<MenuItem | false | undefined>,
): MenuItem[] => items.filter(Boolean) as MenuItem[];
